module.exports = __webpack_public_path__ + "static/media/WU_PAYMENT_card_active.5d2f68c3.svg";